import * as actionTypes from "./types";

const BASE = "/v2/admin/barometre";

export const getVagues = () => ({
  type: actionTypes.GET_VAGUES,
  meta: { async: true, blocking: true, path: `${BASE}/list.json`, method: "GET" },
  payload: {},
});

export const getDetail = (id) => ({
  type: actionTypes.GET_DETAIL,
  meta: { async: true, blocking: true, path: `${BASE}/${id}.json`, method: "GET" },
  payload: { id },
});

export const classify = (id) => ({
  type: actionTypes.CLASSIFY,
  meta: { async: true, blocking: true, path: `${BASE}/${id}/classify.json`, method: "POST", body: {} },
  payload: { id },
});

// payload patch: { verbatim?, themeId?, themeLibelle?, validee? }
export const updateItem = (itemId, patch) => ({
  type: actionTypes.UPDATE_ITEM,
  meta: { async: true, blocking: false, path: `${BASE}/item/${itemId}.json`, method: "POST", body: patch },
  payload: { itemId },
});

// payload patch: { statut?, site?, ressenti?, personne? }
export const updateReponse = (reponseId, patch) => ({
  type: actionTypes.UPDATE_REPONSE,
  meta: { async: true, blocking: false, path: `${BASE}/reponse/${reponseId}.json`, method: "POST", body: patch },
  payload: { reponseId },
});

export const createTheme = (questionId, libelle) => ({
  type: actionTypes.CREATE_THEME,
  meta: { async: true, blocking: false, path: `${BASE}/theme.json`, method: "POST", body: { questionId, libelle } },
  payload: { questionId },
});

export const updateTheme = (themeId, libelle, questionId) => ({
  type: actionTypes.UPDATE_THEME,
  meta: { async: true, blocking: false, path: `${BASE}/theme/${themeId}.json`, method: "PUT", body: { libelle } },
  payload: { themeId, questionId },
});

// Les items pointant le thème repassent à « aucun » (SET NULL côté API).
export const deleteTheme = (themeId, questionId) => ({
  type: actionTypes.DELETE_THEME,
  meta: { async: true, blocking: false, path: `${BASE}/theme/${themeId}.json`, method: "DELETE" },
  payload: { themeId, questionId },
});

export const validateVague = (id) => ({
  type: actionTypes.VALIDATE_VAGUE,
  meta: { async: true, blocking: true, path: `${BASE}/${id}/validate.json`, method: "POST", body: {} },
  payload: { id },
});

// Suppression définitive d'une vague (confirmation demandée côté composant).
export const deleteVague = (id) => ({
  type: actionTypes.DELETE_VAGUE,
  meta: { async: true, blocking: true, path: `${BASE}/${id}.json`, method: "DELETE" },
  payload: { id },
});

// payload: { total, parSite: {site:int}, parStatut: {statut:int} }
export const saveEffectif = (id, effectif) => ({
  type: actionTypes.SAVE_EFFECTIF,
  meta: { async: true, blocking: true, path: `${BASE}/${id}/effectif.json`, method: "POST", body: effectif },
  payload: { id },
});

export const getSynthese = (id) => ({
  type: actionTypes.GET_SYNTHESE,
  meta: { async: true, blocking: true, path: `${BASE}/${id}/synthese.json`, method: "GET" },
  payload: { id },
});

export const getHistory = (site = null, personne = null) => ({
  type: actionTypes.GET_HISTORY,
  meta: {
    async: true,
    blocking: true,
    path: `${BASE}/history.json`,
    method: "GET",
    params: { site, personne },
  },
  payload: {},
});

// ---- Référentiel employés (statuts) ----

export const getEmployes = () => ({
  type: actionTypes.GET_EMPLOYES,
  meta: { async: true, blocking: true, path: `${BASE}/employes.json`, method: "GET" },
  payload: {},
});

export const createEmploye = (personne, statut) => ({
  type: actionTypes.CREATE_EMPLOYE,
  meta: { async: true, blocking: true, path: `${BASE}/employe.json`, method: "POST", body: { personne, statut } },
  payload: {},
});

export const updateEmploye = (id, patch) => ({
  type: actionTypes.UPDATE_EMPLOYE,
  meta: { async: true, blocking: true, path: `${BASE}/employe/${id}.json`, method: "POST", body: patch },
  payload: { id },
});

export const deleteEmploye = (id) => ({
  type: actionTypes.DELETE_EMPLOYE,
  meta: { async: true, blocking: true, path: `${BASE}/employe/${id}.json`, method: "DELETE" },
  payload: { id },
});

// rows: [{ personne, statut }]
export const importEmployes = (rows) => ({
  type: actionTypes.IMPORT_EMPLOYES,
  meta: { async: true, blocking: true, path: `${BASE}/employes/import.json`, method: "POST", body: { rows } },
  payload: {},
});

// Remplit les statuts vides d'une vague depuis le référentiel.
export const applyEmployes = (id) => ({
  type: actionTypes.APPLY_EMPLOYES,
  meta: { async: true, blocking: true, path: `${BASE}/${id}/employes/apply.json`, method: "POST", body: {} },
  payload: { id },
});
